module.exports = __webpack_public_path__ + "img/logo-manyu.f0c6e737.png";